import { Component, Input } from '@angular/core';

@Component({
  selector: 'unico-people-request-list',
  templateUrl: './request-list.component.html',
  styleUrls: ['./request-list.component.scss']
})

export class RequestListComponent {
  @Input() dataSource: any;
  @Input() paginator: any;
  @Input() displayedColumns: any;
  @Input() concluded: boolean;
  @Input() pending: boolean;
}
